// src/Hooks/useActifService.ts
import { useAuthHeader } from '../../Services/Auth/sessionAuth';
import axios from 'axios';
import { Crypter } from '../../Functions/Security/Crypter';
import Data from '../../Data/Data.json';
import ParamsPicklist from '../../Types/ParamsPicklist';

export const useActifService = () => {
  const authHeader = useAuthHeader();

  /**
   * Récupère le Coût initial d'un CodeActif depuis la table Actif.
   * @param codeActif - Code de l'actif
   * @returns Promise<number | null> - Coût initial ou null si non trouvé
   */
  const getCoutInitial = async (codeActif: string): Promise<number | null> => {
    if (!codeActif) return null;

    const params: ParamsPicklist = {
      CodeAgence: '',
      Table: 'Actif',
      Colonne1: 'CodeActif',
      Colonne2: 'CoutInitial',
      Colagence: '',
      Init: codeActif,
      Choix: 1, // SELECT top 1 Colonne2, Colonne1 FROM Table WHERE Colonne2 = Init
      colfiltre: '',
      valfiltre: '',
    };

    try {
      const response = await axios({
        method: 'get',
        url: Data.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader(),
          CypherSearch: Crypter.encrypt(JSON.stringify(params)),
        },
      });

      if (!response.data) return null;

      const result = JSON.parse(Crypter.decrypt(response.data)).Value;

      if (result.StatutCode === 200) {
        const table = result.Result?.Table || [];
        if (table.length > 0) {
          const row = table[0];
          const keys = Object.keys(row);
          if (keys.length > 0) {
            const coutInitial = Number(row[keys[0]]);
            return isNaN(coutInitial) ? null : coutInitial;
          }
        }
      }
      return null;
    } catch (error) {
      console.error('Erreur récupération CoutInitial:', error);
      return null;
    }
  };

  return { getCoutInitial };
};